// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610132236/js/" + chunkId + "." + {"44":"72c715e9","225":"370884b5","481":"50d69b3b","486":"f153a184","770":"ad698502"}[chunkId] + ".0.7203791600585102.chunk.js";
};